import { render, staticRenderFns } from "./AuthWindow.vue?vue&type=template&id=348f16ff"
import script from "./AuthWindow.vue?vue&type=script&lang=js"
export * from "./AuthWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports